import React from "react";
import Cards from "../../components/Cards/Cards";
import "./MainDash.css";
const MainDash = () => {
  return (
    <div>
      <h1>DashBoard</h1>
      <Cards />
    </div>
  );
};
export default MainDash;
